/**
 * Module dependencies.
 */

import { axiosInstance, getApiEndpoint } from 'src/core/requests';
import { snakeCaseObjectKeys } from 'src/core/utils/objects';

/**
 * Export `validatePromoCode` request.
 */

export async function validatePromoCode(promoCode: string) {
  try {
    const response = await axiosInstance.post(
      getApiEndpoint('promoCode'),
      snakeCaseObjectKeys({ promoCode })
    );

    return response?.status === 204;
  } catch (error) {
    return false;
  }
}
